<template>
  <Modal id="pay-invoice">
    <div class="sm:px-[12px] py-[8px] sm:py-[20px] text-[#333333] flex flex-col gap-[16px] sm:gap-[24px]">
      <div>
        <strong class="block text-center font-semibold text-[18px] sm:text-[24px]">Pembayaran Invoice Talent</strong>
        <div class="border border-[#E2E2E2] rounded-[8px] mt-[20px] sm:mt-[24px] p-[12px] sm:p-[16px] flex flex-col gap-[4px] sm:gap-[8px]">
          <span class="text-[12px] sm:text-[16px]">Saldo Kompay</span>
          <b class="font-semibold text-[20px] sm:text-[30px] text-black/90">{{ IDR(kompay) }}</b>
        </div>
        <span
          v-if="kompay < invoice.total_nominal"
          class="pt-[2px] sm:pt-[4px] text-[10px] sm:text-[12px] text-[#E31A1A]"
        >Saldo tidak mencukupi</span>
      </div>
      <div
        v-if="isLowBalanceAfterIdeal || isLowBalanceAfterWithdrawal"
        class="py-[12px] sm:py-[16px] px-[16px] sm:px-[24px] rounded-[8px] bg-[#FFEDED]"
      >
        <b class="flex items-center font-medium text-[10px] sm:text-[12px] gap-[6px] sm:gap-[10px]">
          <i class="k-info-circle text-[#E31A1A] text-[16px]" />
          <span v-if="isLowBalanceAfterIdeal && isLowBalanceAfterWithdrawal">
            Saldo kamu belum bisa digunakan karena sedang diproses untuk penarikan senilai {{ IDR(balance.on_withdrawl) }} dan tertahan sebagai Saldo Ideal Komship. Silakan top-up untuk lanjut transaksi.
          </span>
          <span v-if="isLowBalanceAfterIdeal && !isLowBalanceAfterWithdrawal">
            Sebagian saldo kamu masih ditahan sebagai cadangan Saldo Ideal Komship. Top-up saldo untuk lanjut transaksi, ya!
          </span>
          <span v-if="!isLowBalanceAfterIdeal && isLowBalanceAfterWithdrawal">
            Saldo kamu tidak mencukupi karena sedang diproses untuk penarikan.
          </span>
        </b>
        <p
          v-if="isLowBalanceAfterIdeal"
          class="leading-[14px] text-[10px] sm:text-[12px] sm:leading-[18px] text-[#626262] ml-[22px] sm:ml-[24px] mt-[2px] sm:mt-[4px] mb-[8px] sm:mb-[12px]"
        >
          Saldo ideal diterapkan untuk menghindari saldo minus. <a
            class="text-[#08A0F7] underline hover:text-blue-500"
            href="https://bantuan.komerce.id/id/article/saldo-ideal-komship-7dn9vp/"
            target="_blank"
            rel="noopener noreferrer"
          >Pelajari lebih lanjut</a>
        </p>
        <div
          v-if="isLowBalanceAfterIdeal"
          class="text-[10px] sm:text-[12px] p-[8px] rounded-[8px] bg-white text-[#626262]"
        >
          <span class="font-medium flex items-center gap-[4px]">
            <i class="k-message-question" />
            Darimana Saldo Ideal berasal?
          </span>
          <p class="mt-[2px] sm:mt-[4px] mb-0 leading-[15px] sm:leading-[18px]">
            Potensi Pendapatan Order Dikirim ({{ IDR(balance.income_order_potential) }}) - Ongkir Retur Ketika Sampai ({{ IDR(balance.ongkir_retur_on_finished) }}) - Resiko Ongkir Menjadi Retur ({{ IDR(balance.ongkir_risk_become_retur) }}) = Saldo Ideal <span class="text-[#E31A1A]">({{ IDR(balance.ideal_balance) }})</span>
          </p>
        </div>
      </div>
      <div>
        <b class="font-medium text-[14px] sm:text-[16px]">Total yang harus dibayar:</b>
        <div class="mt-[6px] sm:mt-[8px] flex flex-col gap-[6px] sm:gap-[12px]">
          <div class="flex gap-[12px] sm:gap-[16px] items-center justify-between font-medium text-[12px] sm:text-[14px]">
            <span class="text-[#626262]">Total Insentif Tetap Talent</span>
            <span>{{ invoiceTotalSummary.totalSalaryTalent }}</span>
          </div>
          <div class="flex gap-[12px] sm:gap-[16px] items-center justify-between font-medium text-[12px] sm:text-[14px]">
            <span class="text-[#626262]">Total Biaya Admin</span>
            <span>{{ invoiceTotalSummary.totalAdminFee }}</span>
          </div>
          <div class="flex gap-[12px] sm:gap-[16px] items-center justify-between font-medium text-[12px] sm:text-[14px] pb-[4px] border-b border-[#E2E2E2] border-dashed">
            <span class="text-[#626262]">Biaya Lainnya</span>
            <span>{{ invoiceTotalSummary.totalAdditionalCost }}</span>
          </div>
          <ul class="text-[#828282] text-[10px] sm:text-[12px] mb-0 list-disc">
            <li class="ml-[14px] sm:ml-[16px]">
              <div class="flex gap-[12px] sm:gap-[16px] items-center justify-between">
                <span>{{ invoiceTotalSummary.taxLabel }}</span>
                <span>{{ invoiceTotalSummary.taxValue }}</span>
              </div>
            </li>
            <li class="ml-[14px] sm:ml-[16px] pt-[6px] sm:pt-[12px]">
              <div class="flex gap-[12px] sm:gap-[16px] items-center justify-between">
                <span>Biaya Aplikasi</span>
                <span>{{ invoiceTotalSummary.adminService }}</span>
              </div>
            </li>
          </ul>
          <div class="flex gap-[12px] sm:gap-[16px] items-center justify-between mt-[4px] sm:mt-0">
            <b class="font-medium text-[14px] sm:text-[16px]">Total Invoice</b>
            <b class="font-semibold text-[16px] sm:text-[20px] text-primary">{{ invoiceTotalSummary.totalInvoice }}</b>
          </div>
        </div>
      </div>
      <div class="actions gap-x-[12px] gap-y-[8px] sm:mt-[8px]">
        <b-button
          variant="outline-primary"
          class="grow basis-[50%] whitespace-nowrap"
          @click="$bvModal.hide('pay-invoice')"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="grow basis-[50%] whitespace-nowrap"
          :disabled="loading"
          @click="handleConfirm"
        >
          {{ isLowBalance ? 'Topup Saldo' : 'Bayar Sekarang' }}
        </b-button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { IDR } from '@/libs/currency'
import Modal from './Modal.vue'

export default {
  components: { Modal },
  props: {
    invoice: {
      type: Object,
      default: () => ({
        invoice_code: '',
        total_admin_fee: 0,
        total_salary_talent: 0,
        total_tax: 0,
        total_additional_cost: 0,
        ppn_numerator: 0,
        admin_service: 0,
        total_nominal: 0,
      }),
    },
    balance: {
      type: Object,
      default: () => ({
        ideal_balance: 0,
        ongkir_retur_potential: 0,
        income_order_potential: 0,
        ongkir_retur_on_finished: 0,
        ongkir_risk_become_retur: 0,
        on_withdrawl: 0,
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IDR,
    }
  },
  computed: {
    kompay() {
      return this.$store.state.dashboard.saldo
    },
    invoiceTotalSummary() {
      return {
        totalSalaryTalent: IDR(this.invoice.total_salary_talent),
        totalAdminFee: IDR((this.invoice.total_admin_fee) - (this.invoice.total_tax)),
        totalAdditionalCost: IDR(this.invoice.total_additional_cost),
        taxLabel: `PPN ${this.invoice.ppn_numerator}%`,
        taxValue: IDR(Math.ceil((this.invoice.ppn_numerator / 100) * (this.invoice.total_admin_fee))),
        adminService: IDR(this.invoice.admin_service),
        totalInvoice: IDR(this.invoice.total_nominal),
        invoiceCode: this.invoice.invoice_code,
      }
    },
    isLowBalanceAfterIdeal() {
      return this.balance.ideal_balance > 0 && (this.kompay - this.balance.ideal_balance < this.invoice.total_nominal)
    },
    isLowBalanceAfterWithdrawal() {
      return this.balance.on_withdrawl > 0 && (this.kompay - this.balance.on_withdrawl < this.invoice.total_nominal)
    },
    isLowBalance() {
      return (this.kompay < this.invoice.total_nominal) || this.isLowBalanceAfterIdeal || this.isLowBalanceAfterWithdrawal
    },
  },
  mounted() {
    this.$store.dispatch('dashboard/getBalanceSummary')
  },
  methods: {
    handleConfirm() {
      if (this.isLowBalance) {
        this.$emit('onTopup')
        return
      }
      this.$emit('onPay')
    },
  },
}
</script>

<style scoped>
.actions {
    display: flex;
    flex-direction: column;
}

@media screen and (min-width: 360px) {
    .actions {
        flex-direction: row;
    }
}
</style>
